import {
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  Tooltip,
  Switch,
  IconButton,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import PricingBox from "../Lessons/PricingBox";
import getProMapping from "../Signups/getProMapping";
import dayjs from "dayjs";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LessonPackageSelection from "../Lessons/LessonPackageSelection";
import RecurringEvent from "./RecurringEvent";
import recurringUTCConverter from "./recurringUTCConverter";
import DateTimeLoc from "./DateTimeLoc";
import LeagueRegistration from "./LeagueRegistration";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

function GameRegistrationModal({
  devPort,
  registerModal,
  setRegisterModal,
  clubId,
  setAlertMessage,
  setMessageContent,
  filterGames,
  modalType,
  setGameToDelete,
  setDeleteModal,
  gameToEdit,
  setGameToEdit,
}) {
  const [registerDate, setRegisterDate] = useState();
  const [registerStartTime, setRegisterStartTime] = useState(
    dayjs(moment().set({ hour: 10, minute: 0, second: 0 }))
  );
  const [registerField, setRegisterField] = useState();
  const [registerManagerNotes, setRegisterManagerNotes] = useState();
  const [registerGameType, setRegisterGameType] = useState("OUTDOOR");
  const [selectedPrice, setSelectedPrice] = useState();
  const [recipient, setRecipient] = useState();
  const [recipientId, setRecipientId] = useState();
  const [recipientStripeId, setRecipientStripeId] = useState();
  const [numberHorseChukker, setNumberHorseChukker] = useState(0);
  const [defaultHorseChukker, setDefaultHorseChukker] = useState();
  const [gameId, setGameId] = useState();
  const [showLeagueRegistration, setShowLeagueRegistration] = useState(false);
  const accessMode = modalType === "save" ? "Create" : "Update";
  //Pro Mapping
  const [proMapping, setProMapping] = useState();
  const [registerModalPage2, setRegisterModalPage2] = useState(false);
  const [selectedMembershipPackages, setSelectedMembershipPackages] =
    useState();
  const [recurringDays, setRecurringDays] = useState([]);
  const [recurringEndDate, setRecurringEndDate] = useState("");
  const [gameDivisionDetails, setGameDivisionDetails] = useState([]);
  const [recurringEventKey, setRecurringEventKey] = useState(0);
  function modalReset() {
    setRegisterDate();
    setRegisterStartTime(
      dayjs(moment().set({ hour: 10, minute: 0, second: 0 }))
    );
    setRegisterField();
    setRegisterManagerNotes();
    setRegisterGameType("OUTDOOR");
    setSelectedPrice();
    setRecipient();
    setRecipientStripeId();
    setNumberHorseChukker(defaultHorseChukker);
    setGameId();
    setShowLeagueRegistration(false);
    setGameDivisionDetails([]);
    // Reset recurring event state
    setRecurringDays([]);
    setRecurringEndDate("");
    // Force RecurringEvent to remount and reset its internal state
    setRecurringEventKey(prev => prev + 1);
    if (setGameToEdit) {
      setGameToEdit(null);
    }
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    if (recipientStripeId) {
      fetch(
        devPort +
          "system_get_user_id_from_connect_id/" +
          clubId +
          "/" +
          recipientStripeId,
        { credentials: "include" }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          setRecipientId(data);
        });
    } else {
      console.log("RIGHT THERE");
      console.log(recipientStripeId);
      console.log(recipient);
      setRecipientId(null);
    }
  }, [clubId, recipientStripeId, devPort, recipient]);

  useEffect(() => {
    if (gameToEdit && registerModal) {
      console.log("GAME TO EDIT", gameToEdit);
      setRegisterDate(moment(gameToEdit.raw_date).format("YYYY-MM-DD")); //.format("YYYY-MM-DD"));
      setRegisterStartTime(dayjs(gameToEdit.raw_date));
      setRegisterField(gameToEdit.field_location);
      setRegisterManagerNotes(gameToEdit.manager_notes);
      setRegisterGameType(gameToEdit.game_type);
      setSelectedPrice(gameToEdit.lease_price);
      setRecipientStripeId(gameToEdit.lease_recipient);
      setNumberHorseChukker(gameToEdit.number_horse_chukker || null);
      setGameId(gameToEdit.id);
      setGameDivisionDetails(
        gameToEdit.divisions.map((division) => {
          return {
            league_name: division,
            handicap: 0,
            team_maximum: 2,
          };
        })
      );
      setShowLeagueRegistration(gameToEdit.divisions.length > 0);
      setRegisterModal(true);
    }
  }, [gameToEdit, registerModal, setRegisterModal]);

  // Reset recurring state when modal opens fresh (not editing)
  useEffect(() => {
    if (registerModal && modalType === "save" && !gameToEdit) {
      // Modal opened for new game creation - reset recurring state
      setRecurringDays([]);
      setRecurringEndDate("");
      setRecurringEventKey(prev => prev + 1);
    }
  }, [registerModal, modalType, gameToEdit]);
  useEffect(() => {
    console.log(devPort + "get_horse_chukker_club/" + clubId);
    fetch(devPort + "get_horse_chukker_club/" + clubId)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && data[0]) {
          setNumberHorseChukker(data[0][0]);
          setDefaultHorseChukker(data[0][0]);
        }
      });
  }, [devPort, clubId, setNumberHorseChukker, setDefaultHorseChukker]);

  useEffect(() => {
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, clubId]);

  function verifyFirstPageFields() {
    if (
      !registerDate ||
      !registerStartTime ||
      !moment(registerDate).isValid() ||
      !moment(registerStartTime).isValid()
    ) {
      window.alert("Enter a date and time");
    } else {
      if (!registerField) {
        window.alert("Enter a field name");
      } else {
        setRegisterModal(false);
        setRegisterModalPage2(true);
      }
    }
  }
  function registerGame(registerMode) {
    if (
      !registerDate ||
      !registerStartTime ||
      !moment(registerDate).isValid() ||
      !moment(registerStartTime).isValid()
    ) {
      window.alert("Enter a date and time");
    } else {
      if (!registerField) {
        window.alert("Enter a field name");
      } else {
        if (
          (!selectedPrice && !selectedMembershipPackages && recipient) ||
          (selectedPrice && !recipient) ||
          (selectedMembershipPackages &&
            selectedMembershipPackages.length !== 0 &&
            !recipient)
        ) {
          window.alert(
            "Select a price and a recipient or unselect both of them"
          );
        } else {
          /*const utc_game_time = moment(
            registerDate.format("YYYY-MM-DD") +
              " " +
              registerStartTime.format("HH:mm")
          )
            .utc()
            .format("YYYY-MM-DD HH:mm");*/

          console.log(registerDate);
          console.log(registerStartTime);
          const [recurring_integer, utc_game_time, utc_end_date] = recurringUTCConverter(
            registerDate,
            registerStartTime,
            recurringDays,
            recurringEndDate
          );
          console.log(utc_game_time);
          const game_data = {
            club_id: clubId,
            game_date: utc_game_time,
            field_location: registerField,
            game_type: registerGameType,
            manager_notes: registerManagerNotes ? registerManagerNotes : null,
            lease_price: !selectedPrice ? null : selectedPrice.value,
            lease_recipient: !recipient ? null : recipient.value,
            selected_membership_packages: selectedMembershipPackages,
            number_horse_chukker: numberHorseChukker,
            game_id: gameId,
            recurring_end_date: utc_end_date,
            recurring_days: recurring_integer,
            divisions: gameDivisionDetails.map(
              (division) => division.league_name
            ),
          };
          console.log(game_data);
          const fetch_end_point =
            registerMode === "save" ? "add_game" : "update_game";
          fetch(devPort + fetch_end_point, {
            mode: "cors",
            credentials: "include",
            method: "POST",
            body: JSON.stringify(game_data),
          }).then((data) => {
            setRegisterModal(false);
            setRegisterModalPage2(false);
            //setIsLoading(true);
            modalReset();
            filterGames();
            setRecipient(null);
            setMessageContent(
              registerMode === "save" ? "added to" : "updated in"
            );
            setAlertMessage(true);
          });
        }
      }
    }
  }

  useEffect(() => {
    console.log(devPort + "get_default_membership_club/" + clubId);
    fetch(devPort + "get_default_membership_club/" + clubId)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && data[0] && data[0] && data[0][0]) {
          setSelectedMembershipPackages(data[0]);
        }
      });
  }, [devPort, clubId]);

  return (
    <>
      <Modal
        open={registerModalPage2}
        onClose={() => {
          setRegisterModalPage2(false);
          modalReset();
        }}
        aria-labelledby="Game Registration 2/2"
        aria-describedby="Create new game 2/2"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            <Typography id="game-date" variant="h6" component="h2">
              {accessMode} New Game
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showLeagueRegistration}
                    disabled={gameDivisionDetails.length > 0}
                    onChange={(e) =>
                      setShowLeagueRegistration(e.target.checked)
                    }
                  />
                }
                label="Add Game Divisions"
              />
              <Tooltip title="For instance, if you want to have slow chukkers and fast chukkers, you can register those and players will sign up for their corresponding chukkers">
                <IconButton size="small">
                  <HelpOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            {showLeagueRegistration && (
              <LeagueRegistration
                onReset={() => {}}
                leaguesDetails={gameDivisionDetails}
                setLeaguesDetails={setGameDivisionDetails}
                displayHandicap={false}
                title="Game Division"
              />
            )}
            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
              Pricing Information
            </Typography>
            <PricingBox
              devPort={devPort}
              clubId={clubId}
              selectedPrice={selectedPrice}
              setSelectedPrice={setSelectedPrice}
              recipient={recipient}
              setRecipient={setRecipient}
              proMapping={proMapping}
              tableType="Lease"
              recipientId={recipientId}
            />
            <TextField
              id="add-chukker-horse-number"
              label="Number of chukker horse to lease"
              data-testid="add-horse-number"
              style={{ width: "100%" }}
              value={numberHorseChukker}
              disabled={!selectedPrice}
              onChange={(input) => {
                const intLesson = parseInt(input.target.value);
                if (!Number.isNaN(intLesson)) {
                  setNumberHorseChukker(intLesson);
                } else {
                  setNumberHorseChukker("");
                }
              }}
            />
            <LessonPackageSelection
              devPort={devPort}
              clubId={clubId}
              selectedPackages={selectedMembershipPackages}
              setSelectedPackages={setSelectedMembershipPackages}
              tableType="Membership"
              multiple_packages={true}
            />
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                {modalType === "save" && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => registerGame("save")}
                    style={{ width: "100%" }}
                  >
                    Save Game
                  </Button>
                )}
                {modalType === "update" && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => registerGame("update")}
                    style={{ width: "100%" }}
                  >
                    Update Game
                  </Button>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  variant="outlined"
                  color="error"
                  style={{ width: "100%" }}
                  onClick={() => {
                    setRecipient(null);
                    setRegisterModalPage2(false);
                    modalReset();
                  }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={registerModal}
        onClose={() => {
          setRegisterModal(false);
          modalReset();
        }}
        aria-labelledby="Game Registration"
        aria-describedby="Create new game"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            <DateTimeLoc
              modalMode={accessMode + " New Game"}
              registerDate={registerDate}
              registerStartTime={registerStartTime}
              registerField={registerField}
              setRegisterDate={setRegisterDate}
              setRegisterStartTime={setRegisterStartTime}
              setRegisterField={setRegisterField}
            />
            {/*<Typography id="game-date" variant="h6" component="h2">
              {accessMode} New Game
            </Typography>
            <DatePicker
              value={registerDate ? dayjs(registerDate) : null}
              onChange={(event) => {
                console.log(event);
                //setRegisterDate(moment(event["$d"])); // format("YYYY-MM-DD"));
                if (event) {
                  setRegisterDate(moment(event["$d"]).format("YYYY-MM-DD"));
                }
              }}
            />
            <TimePicker
              label="Set Start Time"
              value={registerStartTime}
              onChange={(event) => {
                console.log(event);
                setRegisterStartTime(event);
                //setRegisterStartTime(moment(event["$d"]));
                //console.log(moment(event["$d"]).format("HH:mm"));
              }}
            />
            <TextField
              id="field-name"
              label="Field Name"
              variant="filled"
              value={registerField}
              onChange={(event) => {
                setRegisterField(event.target.value);
              }}
            />*/}
            <TextField
              id="manager-notes"
              label="Details"
              variant="filled"
              value={registerManagerNotes}
              onChange={(event) => {
                setRegisterManagerNotes(event.target.value);
              }}
            />
            <FormLabel id="game-type-group-label">Game Type</FormLabel>
            <RadioGroup
              row
              aria-labelledby="game-type-group-label"
              value={registerGameType}
              name="game-type-picker"
              onChange={(event) => {
                setRegisterGameType(event.target.value);
              }}
            >
              <FormControlLabel
                value="OUTDOOR"
                control={<Radio />}
                label="Outdoor"
              />
              <FormControlLabel
                value="ARENA"
                control={<Radio />}
                label="Arena"
              />
            </RadioGroup>
            {modalType === "save" && (
              <RecurringEvent
                key={`recurring-${recurringEventKey}`}
                recurringDays={recurringDays}
                setRecurringDays={setRecurringDays}
                setRecurringEndDate={setRecurringEndDate}
                mode="Game"
              />
            )}
            {modalType === "update" && (
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setGameToDelete(gameId);
                  setRegisterModal(false);
                  setDeleteModal(true);
                }}
              >
                <DeleteIcon />
                Delete Game
              </Button>
            )}
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="primary"
                  onClick={verifyFirstPageFields} //registerLesson}
                >
                  <NavigateNextIcon />
                  Next
                </Button>
              </Grid>
              <Grid size={{ xs: 6 }} xsOffset={1}>
                <Button
                  variant="outlined"
                  color="error"
                  style={{ width: "100%" }}
                  onClick={() => {
                    setRecipient(null);
                    setRegisterModal(false);
                    modalReset();
                  }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

export default GameRegistrationModal;
